<template>
    <div class="modal-conflito" style="z-index: 99999999999999999999999!important;">
        <!-- Modal -->
        <v-dialog v-model="configDefault.show" max-width="600px" tabindex="2" style="z-index: 99999999999999999999999!important;">
            <v-card class="modal--tips4y">
                <v-card-title>
                    <h2>{{$t('module-budget.modal-change-operation.card-title')}}</h2>
                </v-card-title>

                <v-card-text v-if="items.type">
                    <div class="box__texts" style="min-height: 295px;">

                        <div class="row--texts mb-2">
                            <h2>{{$t('module-budget.modal-change-operation.for-change1')}}</h2>
                            <div class="items-texts mt-2">
                                <p>{{ mixinCheckboxValue(items.type, items.oldItem).value }}</p>
                                <p>{{ items.oldItem.workPosCriteriaDescription }}</p>
                            </div>
                        </div>

                        <div class="row--texts mt-3">
                            <h2>{{$t('module-budget.modal-change-operation.for-change2')}}</h2>
                            <div class="items-texts  mt-2">
                                <p>{{ mixinCheckboxValue(items.type, items.newItem).value }}</p>
                                <p>{{ items.newItem.workPosCriteriaDescription }}</p>
                            </div>
                        </div>

                    </div>
                </v-card-text>

                <v-card-actions class="align__flex--space-between">
                    <v-btn class="danger-button" text @click="cancelModal">
                        {{$t('module-budget.modal-change-operation.cancel')}}
                    </v-btn>
                    <v-btn class="primary-button" text @click="changedItemSelection">
                        {{$t('module-budget.modal-change-operation.change')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Modal -->
    </div>
</template>

<script>
import mixinCheckbox from '@mixins/b2b/budget/checkboxValue.js';
import { QuotationServicesGetOptionsClutchKit } from '@services/b2b/quotation/QuotationServices.js';
export default {
    data() {
        return {
            configDefault: {
                show: false,
                texts: {
                    title: this.$t('module-budget.modal-change-operation.config-default.title'),
                    message: this.$t('module-budget.modal-change-operation.config-default.message'),
                },
                operation: {}
            },
            list: [],
            items: {
                oldItem: null,
                newItem: null,
                type: null
            },
            optionsKit: []
        };
    },
    mixins: [mixinCheckbox],
    components: {},
    props: {},

    computed: {
        getB2bWatchNeedToCheckItemMpId() {
            return this.$store.getters['budget/getB2bWatchNeedToCheckItemMpId'];
        }
    },
    watch: {
        getB2bWatchNeedToCheckItemMpId(newItem, OldItem) {
            if (newItem) {
                this.items.type = newItem.type;
                this.items.newItem = newItem.item;

                this.configDefault.show = true;
                this.catchOldItem(this.items.newItem);
                this.$store.commit('budget/setB2bResetNeedToCheckItemMpId');
            }
        }
    },
    methods: {
        cancelModal() {
            this.items= {
                oldItem: null,
                newItem: null,
                type: null
            }
            this.configDefault.show = false;
        },

        async changedItemSelection() {
            let payload = {
                item: this.items.oldItem,
                type: this.items.type
            };
            this.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);

            payload.item = this.items.newItem;
            this.$store.commit('budget/setB2bRemoveOrAddShoppingCartItem', payload);

            this.configDefault.show = false;

            await this.$nextTick();

            if(payload.item.itemMpId == 127) {
              const getShoppingCartOperations = this.$store.getters['budget/getB2bCurrentShoppingCart'].operations;
              const concatMaintenanceWithRepairLists = getShoppingCartOperations.maintenance.concat(getShoppingCartOperations.repair);
              const existKitOnList = concatMaintenanceWithRepairLists.find(item => item.itemMpId == 127);
              if(existKitOnList) {
                this.getClutchKit();
              }
            }
        },

        forceReloadShoppingCart() {
            this.$store.commit('budget/setB2bForceReloadShoppingCart');
        },

        catchOldItem(newItem) {
            let listState = this.$store.getters['budget/getB2bCurrentShoppingCart'].operations;

            listState[this.items.type].filter((item, index) => {
                if (item.itemMpId === this.items.newItem.itemMpId) {
                    this.items.oldItem = item;
                }
            });
        },

        getClutchKit() {
          this.$store.commit('loadings/setStateLoadingTemplate', true);
          QuotationServicesGetOptionsClutchKit()
            .then(response => {
              if(response.data.result && response.data.result.length > 0) {
                let res = response.data.result;
                res.forEach((element, index) => {
                  Object.assign(element, { selected: null});
                })
                this.optionsKit = res;

                const payload = {
                  show: true,
                  data: null,
                  options: this.optionsKit,
                  removePartIDs: []
                }
                this.$store.commit('budget/setStateOfClutchKit', payload)
              }
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              this.$store.commit('loadings/setStateLoadingTemplate', false);
            })
        },
    }
};
</script>

<style lang="scss">
@import '@sass/_variables.scss';

.modal--tips4y {
    .box__texts {
        padding: 10px 0;
        .row--texts {
            margin: 10px 0;

            .items-texts {
                margin: 15px 0 20px;

                p {
                    margin: 0 !important;
                    font-size: 18px;
                    font-family: Lato;
                    line-height: 1.5em;
                    font-weight: 400;
                    color: $grey-dark;

                    &:last-child {
                        font-size: 16px;
                        line-height: 1.1em;
                        color: $grey;
                    }
                }
            }
        }
    }
}

</style>
